
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hard/atoms/japan/pitcher",
      function () {
        return require("private-next-pages/hard/atoms/japan/pitcher/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hard/atoms/japan/pitcher"])
      });
    }
  